import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'E-mailbeskeder',
  labels: {
    view_full_message: 'Se hele beskeden',
    status: 'Status:',
    on: 'Til',
    off: 'Fra',
    next_send: 'Næste afsendelse: {{date}}.',
  },
  descriptions: {
    welcome:
      'Sendes én gang, når en kunde tilmelder sig dine marketingmails, bortset fra tilmeldinger via din storefront-formular. En kunde får kun én af Velkommen, Velkommen medlemsklub og Åbningstilbud.',
    welcome_members_club:
      'Sendes én gang, når nogen tilmelder sig via din storefront-formular, og der ikke er oprettet nogen tilmeldingspromokode, eller når de kommer på din VIP-medlemsliste. En kunde får kun én af Velkommen, Velkommen medlemsklub og Åbningstilbud.',
    storefront_promo:
      'Sendes én gang, når nogen tilmelder sig via din storefront-formular, mens der er oprettet en tilmeldingspromokode. Mailen indeholder deres personlige promokode.',
    launch_deal:
      'Sendes én gang til dine importerede kunder 30 minutter efter, at din restaurant går live. Kunder, der allerede har fået Velkommen eller Velkommen medlemsklub, springes over.',
    we_miss_you:
      'Sendes til abonnenter, hvis seneste ordre er mere end 45 dage gammel. Tjekkes hver morgen; en kunde får den højst én gang hver 45. dag.',
    happy_friday:
      'Sendes til alle abonnenter kl. 08:00 UTC den første fredag i hver lige måned (februar, april, juni, august, oktober, december).',
    lazy_sunday:
      'Sendes til alle abonnenter kl. 08:00 UTC den første søndag i hver ulige måned (januar, marts, maj, juli, september, november).',
    loyalty_program:
      'Sendes, når en kundes cashback-saldo når det minimum, kunden kan bruge. En kunde får den højst én gang hver 30. dag.',
    you_might_also_like:
      'Sendes 3 dage efter en ordre med mindst 2 af den samme vare til en pris på 6,00 eller mere, og anbefaler en af dine mest populære varer. En kunde får den højst én gang hver 30. dag.',
  },
  tiles: {
    sends_count: 'Sendte beskeder',
    delivery_rate: 'Leveringsrate',
    delivered_suffix: 'leveret',
    open_rate: 'Åbningsrate',
    opened_suffix: 'åbnet',
    click_rate: 'Klikrate',
    clicked_suffix: 'klikket',
    spam_report_rate: 'Spamrapporteringsrate',
    spam_reports_suffix: 'rapporter',
    unsubscribe_rate: 'Afmeldingsrate',
    unsubscribes_suffix: 'afmeldinger',
  },
  toasts: {
    failed_to_update_status: 'Status kunne ikke opdateres',
    failed_to_load_data: 'Data kunne ikke indlæses',
  },

  preview_modal: {
    title: 'Skabelonvisning',
    labels: {
      subject: 'Emne:',
      close: 'Luk',
    },
    toasts: {
      failed_to_load_data: 'Forhåndsvisningen kunne ikke indlæses',
    },
    template_data: {
      recipient_name: '&lt;Fornavn&gt;',
    },
  },
};
